var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDcEmpujeRiesgo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M45.1,26.18a1.8,1.8,0,0,0-1.58-1H34.35L36.42,9.36a1.77,1.77,0,0,0-3.16-1.3L15.08,32a1.77,1.77,0,0,0,1.4,2.84h9.17L23.58,50.64a1.76,1.76,0,0,0,1.08,1.87,1.7,1.7,0,0,0,.67.13,1.77,1.77,0,0,0,1.41-.7L44.92,28A1.77,1.77,0,0,0,45.1,26.18ZM29.41,33.26a1.76,1.76,0,0,0-1.75-2H20.05l12-15.8L30.58,26.74a1.82,1.82,0,0,0,.43,1.4,1.74,1.74,0,0,0,1.34.59H40l-12,15.8Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcEmpujeRiesgo);
export default __webpack_public_path__ + "static/media/DC__Empuje_riesgo.d9d34d5095ee1a0827a421c94d97c92a.svg";
export { ForwardRef as ReactComponent };